module.exports = __webpack_public_path__ + "static/hard-landing-6fac54a49760ca0652c64bda9846d186.jpg";